module.exports = __webpack_public_path__ + "static/media/resume.cf2d8803.svg";